<template>
  <div class="gallery-page-wrapper">
    <NavigationBarTop />
    
    <div class="gallery-page-container">
      <h2 class="page-title">Gallery: Our Craftsmanship</h2>
      
      <form @submit.prevent class="filter-form">
        <select v-model="selectedCategory" class="category-select">
          <option value="">All Arts 2026 & Styles</option>
          <option value="hair">Hair</option>
          <option value="nails">Nails</option>
          <option value="skin">Skin</option>
          <option value="misc">Miscellaneous</option> 
        </select>
      </form>
      
      <div class="gallery_list">
        <div class="g_images" v-for="img in filteredGallery" :key="img.id">
          <div class="image-container">
            <img 
              v-if="img.filename" 
              :src="getImageUrl(img.filename)" 
              alt="Gallery Image" 
              class="image-preview"
            >
            <div v-else class="mock-image-placeholder">
              [No Image: {{ img.caption }}]
            </div>
            
            <div class="caption-overlay">
              <p class="image-caption">{{ img.caption }}</p>
            </div>
          </div>
        </div>
      </div>

      <p v-if="filteredGallery.length === 0" class="no-images-msg">
        No masterpieces found in this category. Expand your search.
      </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NavigationBarTop from '../components/NavigationBarTop.vue'

// const API_BASE = "http://127.0.0.1:5000/api/gallery"
// check me
const API_BASE = 'https://api.kcafrobraids.com/api/gallery' //`${process.env.VUE_APP_API_URL}/gallery`
const GALLERY_STORAGE_KEY = 'salonGallery'; 

export default {
    name: 'Gallery',
    components: {
        NavigationBarTop
    },
    data() {
        return {
            gallery: [], // Will be populated from localStorage
            selectedCategory: '' // State for filtering
        }
    },
    async created(){
        const data = await this.loadGallery()
        console.log("Here is the data belo!!")
        console.log(data)
        if (data){
            this.gallery = data
        }
    },
    computed: {
        // Filters the gallery items based on the selected category
        filteredGallery() {
            if (!this.selectedCategory) {
                return this.gallery;
            }
            console.log("In filtered gallery")
            console.log(this.selectedCategory)
            return this.gallery.filter(img => img.category === this.selectedCategory);
        }
    },
    
    methods: {
        async loadGallery() {
            console.log("In load gallery function")
           
           // function to load the entire gallery
           try{
            const response = await axios.get(`${API_BASE}/get-all`)
            return response.data
           }
           catch(error) {
            console.log("Error", error)
           }
        },
        getImageUrl(imagePath){
            console.log("In get image function")
            return `https://api.kcafrobraids.com/uploads/gallery/${imagePath}`
        }
    }
}
</script>

<style scoped>
.gallery-page-container {
    max-width: 1400px; /* Slightly wider for masonry */
    margin: 0 auto;
    padding: 20px;
}

/* --- Masonry Engine --- */
.gallery_list {
    column-count: 3; /* Number of columns */
    column-gap: 20px; /* Space between columns */
    width: 100%;
}

.g_images {
    display: block;
    width: 100%;
    margin-bottom: 20px; /* Vertical gap between images */
    break-inside: avoid; /* Prevents the image from splitting across columns */
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    border: 1px solid #e0e0e0;
}

.g_images:hover {
    transform: scale(1.02);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

/* --- Image Behavior --- */
.image-container {
    position: relative;
    width: 100%;
}

.image-preview {
    width: 100%;
    height: auto; /* Natural height - NO DISTORTION */
    display: block;
    object-fit: cover;
}

/* --- Hover Overlay (Pinterest Style) --- */
.caption-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(121, 85, 72, 0.85); /* Earthy brown with transparency */
    color: white;
    padding: 15px;
    opacity: 0; /* Hidden by default */
    transition: opacity 0.3s ease;
    text-align: center;
}

.g_images:hover .caption-overlay {
    opacity: 1; /* Shows only on hover */
}

.image-caption {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
    font-family: 'Georgia', serif;
}

/* --- Responsive Adjustments --- */
@media (max-width: 1000px) {
    .gallery_list {
        column-count: 2; /* 2 columns for tablets */
    }
}

@media (max-width: 600px) {
    .gallery_list {
        column-count: 1; /* Single column for mobile */
    }
    .page-title {
        font-size: 1.8rem;
    }
}

/* --- Keep your existing Page Title and Filter Styles --- */
.page-title {
    font-size: 2.5rem;
    color: #795548;
    text-align: center;
    margin-bottom: 2rem;
    text-transform: uppercase;
}

.category-select {
    padding: 12px 20px;
    border: 2px solid #795548;
    border-radius: 25px;
    background-color: #FFF8E1;
    width: 100%;
    max-width: 350px;
    margin: 0 auto 3rem;
    display: block;
}
</style>